import { Badge, Text } from "@mantine/core";
import { memo } from "react";
import "./OrganizerStatus.scss";

interface OrganizerStatusProps {
  organizerStatus: string;
  organizerDate?: string;
  resubmitted?: boolean;
}

const getOrganizerStatus = (organizerStatus: string, resubmitted?: boolean) => {
  switch (organizerStatus) {
    case "complete":
      if (resubmitted) {
        return (
          <Badge
            variant="filled"
            color="#3B82F6"
            radius="xl"
            size="lg"
            styles={{
              root: {
                textTransform: "none",
                fontWeight: 500,
                fontSize: "14px",
                padding: "4px 12px",
                height: "28px",
              },
            }}
          >
            Re-Submitted
          </Badge>
        );
      }
      return (
        <Badge
          variant="filled"
          color="#10B981"
          radius="xl"
          size="lg"
          styles={{
            root: {
              textTransform: "none",
              fontWeight: 500,
              fontSize: "14px",
              padding: "4px 12px",
              height: "28px",
            },
          }}
        >
          Submitted
        </Badge>
      );
    case "in progress":
      return (
        <Badge
          data-testid="in-progress"
          variant="filled"
          color="#0EA5E9"
          radius="xl"
          size="lg"
          styles={{
            root: {
              textTransform: "none",
              fontWeight: 500,
              fontSize: "14px",
              padding: "4px 12px",
              height: "28px",
            },
          }}
        >
          In Progress
        </Badge>
      );
    default:
      return (
        <Badge
          variant="filled"
          color="#6B7280"
          radius="xl"
          size="lg"
          styles={{
            root: {
              textTransform: "none",
              fontWeight: 500,
              fontSize: "14px",
              padding: "4px 12px",
              height: "28px",
            },
          }}
        >
          Not Started
        </Badge>
      );
  }
};

const OrganizerStatus = memo(
  ({ organizerStatus, organizerDate, resubmitted }: OrganizerStatusProps) => {
    const status = getOrganizerStatus(organizerStatus, resubmitted as boolean);
    return (
      <div className="organizer-status" data-testid="organizer-status">
        {status}
        {organizerDate && (
          <Text c="dimmed" fw={500} size="sm">
            {organizerDate}
          </Text>
        )}
      </div>
    );
  }
);

OrganizerStatus.displayName = "OrganizerStatus";

export default OrganizerStatus;
